import PlayerPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default PlayerPage;
